<template>
    <span v-for="item in errors" :key="item" class="error">
        {{ item }}
    </span>
</template>
<script>
export default {
    props: {
        errors: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>
